import * as React from "react";
import style from "./productlist.module.scss";
import { currencyFormatter } from "../../lib/common";
import {
  ButtonDataInfo,
  ButtonGroupContainer,
} from "../Common/ButtonGroupContainer";
import { useProductContext } from "./product-context";
import { AttributeOption } from "./types";

export const AttributeButtons: React.FunctionComponent<{
  options: AttributeOption[];
  onSelected: (option: AttributeOption | undefined) => void;
}> = (props) => {
  const context = useProductContext();

  if (!props.options) {
    return null;
  }

  const onSelectHandler = (selected: ButtonDataInfo) => {
    const option = props.options.find(
      (val) => val.Id.toString() === selected.key
    );
    props.onSelected(option);
  };

  const textTemplate = (option: AttributeOption): JSX.Element => {
    let attributeValue = option.Name;
    const priceDisplay = currencyFormatter.format(option.Price);

    if (context.product) {
      attributeValue = attributeValue.replace(context.product.Name, "");
      attributeValue = attributeValue.replace(`(${priceDisplay})`, "");
      attributeValue = attributeValue.replace(`(${option.Price})`, "");
    }

    if (attributeValue.substring(0, 3) === " - ") {
      attributeValue = attributeValue.substring(3);
    }

    return (
      <span className={style.attributeTextContainer}>
        <span className={style.value}>{attributeValue}</span>
        {option.Price > 0 && (
          <span className={style.price}>{priceDisplay}</span>
        )}
      </span>
    );
  };

  const buttonData: Array<ButtonDataInfo> = props.options.map((option) => {
    return {
      key: option.Id.toString(),
      text: textTemplate(option),
    };
  });

  return (
    <div className={style.attributeButtonContainer}>
      <ButtonGroupContainer
        buttonData={buttonData}
        onSelect={onSelectHandler}
      ></ButtonGroupContainer>
    </div>
  );
};
